var _path, _circle, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractorBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 99,
    viewBox: "0 0 66 99",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 0C2.23858 0 0 2.23858 0 5V94C0 96.7614 2.23858 99 5 99H61C63.7614 99 66 96.7614 66 94V5C66 2.23858 63.7614 0 61 0H5ZM22.2558 5.37208C21.4081 5.37208 20.7209 6.05927 20.7209 6.90697C20.7209 7.75466 21.4081 8.44185 22.2558 8.44185H42.9768C43.8244 8.44185 44.5116 7.75466 44.5116 6.90697C44.5116 6.05927 43.8244 5.37208 42.9768 5.37208H22.2558Z",
    fill: "#CC3333"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.9999,
    cy: 52.6744,
    r: 23.7907,
    fill: "#E08585"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1917 64.09C19.2619 63.5666 19.3158 63.0378 19.4076 62.5198C20.1145 58.7154 22.1002 55.7424 25.2514 53.5028C27.4314 55.5695 30.0001 56.6596 33.0002 56.6541C35.9896 56.6541 38.5529 55.5749 40.7543 53.4921C41.1913 53.8374 41.65 54.1666 42.0709 54.5389C44.7258 56.897 46.2905 59.8379 46.7168 63.3724C46.7438 63.6098 46.7816 63.8526 46.8139 64.0901V64.9534H19.186C19.1914 64.6674 19.1914 64.3761 19.1914 64.0901L19.1917 64.09Z",
    fill: "#FDD8D8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6531 37.3256C34.1981 37.4335 34.7539 37.5036 35.2827 37.6547C38.5204 38.5559 40.9163 41.4212 41.2509 44.7722C41.715 49.4181 38.3047 53.4977 33.6369 53.8809C29.4333 54.2316 25.5643 51.2368 24.8521 47.0764C24.0858 42.63 26.8648 38.4858 31.2734 37.5091C31.6295 37.4282 31.9964 37.385 32.358 37.3257H33.653L33.6531 37.3256Z",
    fill: "#FDD8D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractorBadge);
export default __webpack_public_path__ + "static/media/contractorBadge.23d0c199efe987e3b08758cbff04de3c.svg";
export { ForwardRef as ReactComponent };